import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { TripItemEditRoute } from "../../../../routesConstants";
import DataTable from "../../../../../components/dataTable";
import { PortletBody } from "../../../../../components/Portlet";
import moment from "moment";
import RemoveLink from "../../../../air/airBooking/components/removeLink";
import { connect } from "react-redux";
import { DeleteItem } from "../../../../../redux/actions/base";
import FindOptions from "../../../../air/airBooking/components/findOptions";

const TicketsTab = props => {
  const [refetch, setRefetch] = useState(false);
  const [secondaryLoad, setSecondaryLoad] = useState(false)

  const [query, setQuery] = useState({
    name:'',
    execDate:[],
    tourUser: ''
  });

  useEffect(() => {
    if(props.active && !secondaryLoad){
      setSecondaryLoad(true)
    }
  }, [props.active]);
  const remove = id => {
    props.DeleteItem(`/api/trips/item/${id}`, () => {
      setRefetch(!refetch);
    });
  };
  const columns = [
    {
      Header: "Маршрут",
      accessor: "route",
      Cell: ({ value, row }) => (
        <Link to={TripItemEditRoute + row.original._id}>{value}</Link>
      )
    },
    {
      Header: "Пассажир",
      accessor: "paxes",
      Cell: ({ value, row }) => (
        <>
          {row.original.pax.lastName} {row.original.pax.firstName}
        </>
      )
    },
    {
      Header: "Даты",
      accessor: "dates",
      Cell: ({ value, row }) =>
        row.original.dates.map(d => (
          <React.Fragment>
            {moment(d).format("DD.MM.YYYY")}
            <br />
          </React.Fragment>
        ))
    },
    {
      Header: "Действия",
      Cell: ({ value, row }) => (
        <>
          <Link
            className={"btn btn-sm btn-clean btn-icon btn-icon-md"}
            to={TripItemEditRoute + row.original._id}
          >
            <i className={"la la-edit"} />
          </Link>
          <RemoveLink
            onClick={() => remove(row.original._id)}
            noText
            title={"элемент отеля"}
          />
        </>
      )
    }
  ];
  return (
    <>
      <FindOptions query={query} setQuery={setQuery}/>
      {(props.active || secondaryLoad) && <DataTable
        columns={columns}
        url={`/api/trips/item/ticketList`}
        refetch={refetch}
        search={query}
      />}
    </>
  );
};
export default connect(() => ({}), { DeleteItem })(TicketsTab);
